import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import LogoutIcon from '@mui/icons-material/Logout';

const InactivityDialog = ({
  open,
  remainingTime,
  onContinue,
  onLogout,
}) => {
  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    if (mins > 0) {
      return `${mins}:${secs.toString().padStart(2, '0')}`;
    }
    return `${secs} seconds`;
  };

  return (
    <Dialog
      open={open}
      onClose={() => {}}
      maxWidth="xs"
      fullWidth
      sx={{
        '& .MuiDialog-container': {
          alignItems: 'flex-start',
          paddingTop: '0px',
        },
      }}
      PaperProps={{
        sx: {
          borderRadius: '12px',
          padding: '8px',
        },
      }}
    >
      <DialogTitle
        sx={{
          textAlign: 'center',
          pb: 1,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            mb: 2,
          }}
        >
          <Box
            sx={{
              width: 64,
              height: 64,
              borderRadius: '50%',
              background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <AccessTimeIcon sx={{ fontSize: 32, color: '#fff' }} />
          </Box>
        </Box>
        <Typography variant="h6" fontWeight={600}>
          Session Timeout Warning
        </Typography>
      </DialogTitle>

      <DialogContent sx={{ textAlign: 'center', pt: 0 }}>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
          You have been inactive for a while. For security reasons, your session
          will expire soon.
        </Typography>
        
        <Box
          sx={{
            backgroundColor: 'rgba(245, 158, 11, 0.1)',
            borderRadius: '8px',
            padding: '16px',
            mb: 2,
          }}
        >
          <Typography variant="body2" color="text.secondary">
            Time remaining:
          </Typography>
          <Typography
            variant="h4"
            sx={{
              fontWeight: 700,
              color: remainingTime <= 10 ? '#ef4444' : '#f59e0b',
              fontFamily: 'monospace',
            }}
          >
            {formatTime(remainingTime)}
          </Typography>
        </Box>

        <Typography variant="body2" fontWeight={500}>
          Do you want to continue your session?
        </Typography>
      </DialogContent>

      <DialogActions
        sx={{
          justifyContent: 'center',
          gap: 2,
          pb: 3,
          px: 3,
        }}
      >
        <Button
          variant="outlined"
          color="error"
          onClick={onLogout}
          startIcon={<LogoutIcon />}
          sx={{
            minWidth: 120,
            borderRadius: '8px',
            textTransform: 'none',
            fontWeight: 600,
          }}
        >
          No, Logout
        </Button>
        <Button
          variant="contained"
          onClick={onContinue}
          sx={{
            minWidth: 120,
            borderRadius: '8px',
            textTransform: 'none',
            fontWeight: 600,
            background: 'linear-gradient(135deg, #5b7ab8 0%, #3c5a98 100%)',
            '&:hover': {
              background: 'linear-gradient(135deg, #4a6a9e 0%, #2d4578 100%)',
            },
          }}
        >
          Yes, Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default InactivityDialog;
